import UpdateTransactionLimitDialog from "./update-transaction-limit-dialog.container";

export default UpdateTransactionLimitDialog;
